import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Collapse } from 'reactstrap';

import './ControlledSection.scss';

export const ControlledSection = props => {
  const { name, children, className, expanded: expandedProp, toggleExpanded } = props;

  // State Management (when using as uncontrolled component)
  const [internalExpandedState, setInternalExpandedState] = React.useState(expandedProp !== undefined ? expandedProp : true);

  const isControlled = expandedProp !== undefined && toggleExpanded;
  const isExpanded = isControlled ? expandedProp : internalExpandedState;

  // Event Handlers
  const handleToggle = isControlled
    ? toggleExpanded
    : () => {
        setInternalExpandedState(!internalExpandedState);
      };

  return (
    <div className={`section ${className || ''}`}>
      <div className="section-header">
        <FontAwesomeIcon className="collapse-icon" icon="caret-left" rotation={isExpanded ? 270 : 180} onClick={handleToggle} />
        <span className="name">{name}</span>
      </div>
      <Collapse isOpen={isExpanded} className="section-body">
        {children}
      </Collapse>
    </div>
  );
};

export default ControlledSection;
